import { useCallback } from "react";
import { useAppStore } from "@/common/store/appStore";
import { mainBus } from "@/common/buses";

interface IUsePlayerActionsProps {
  id: string;
}

export const usePlayerActions = (props: IUsePlayerActionsProps) => {
  const { id } = props;
  const isForceFS = useAppStore((state) => state.isForceFS);
  const setGIFQuality = useAppStore((state) => state.setGifQuality);

  const toggleQuality = useCallback((type: string) => setGIFQuality(type), [setGIFQuality]);

  const handleToggleFullScreen = useCallback(() => {
    mainBus.emit("toggle_fullscreen", { id, isForceFS });
  }, [id]);

  return {
    toggleQuality,
    handleToggleFullScreen
  };
};
